"use strict";

/* -------------------------------------------------------------------------

	PUNITED.products

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.products) PUNITED.products = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.products;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.handleProductCategoryNav();
  PUNITED.utils.anchorMenu();
});